import { useLayoutEffect, useEffect, useRef } from 'react'

type UseIntervalOptions = {
  delay?: number | null
}

function useInterval(callback: () => void, { delay }: UseIntervalOptions = {}) {
  const savedCallback = useRef(callback)

  useLayoutEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (typeof delay !== 'number') {
      return
    }

    const id = setInterval(() => {
      savedCallback.current()
    }, delay)

    return () => {
      clearInterval(id)
    }
  }, [delay])
}

export default useInterval
